import { gql } from "@apollo/client";

export const AdjacentClassesQuery = gql`
  query GetAdjacentClasses($databaseId: ID!) {
    adjacentInducteeClasses(databaseId: $databaseId) {
      title
      inducteeData {
        inducteeClass {
          slug
        }
      }
    }
  }
`